import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { PersonalizedSearch } from 'site-modules/personalized-search/pages/personalized-search';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { decoratorParams } from 'site-modules/shared/pages/decorators/decorator-params';
import { SearchResultsContextProvider } from 'site-modules/personalized-search/context/search-results-context/search-results-context-provider';

export function PersonalizedSearchPage(props) {
  return (
    <SearchResultsContextProvider>
      <PersonalizedSearch {...props} />
    </SearchResultsContextProvider>
  );
}

export const pageConfiguration = {
  name: 'personalized_search',
  category: 'search',
  component: PersonalizedSearchPage,
  decorator: decoratorParams(EdmundsCpaNoAdhesionDecorator, {
    showSearchBar: false,
    className: 'personalized-search-page',
    withAiLink: false,
  }),
  seo: { robots: { noIndex: true, noFollow: true } },
  options: {
    disableScrollToTop: true,
  },
};

export default pageDefinition(pageConfiguration);
